<div [ngStyle]="{ height: height, width: width }" class="prf-image-container">
  <img class="prf-image" [ngSrc]="image.src" [alt]="image.alt" [width]="image.width" [height]="image.height" [priority]="priority" />
</div>
